<template>
  <svg
    :width="width ? width : height ? height * (14 / 9) : 14"
    :height="height ? height : width ? width * (9 / 14) : 9"
    viewBox="0 0 14 9"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <g
        id="Detalje-2b"
        transform="translate(-442.000000, -274.000000)"
        :stroke="iconColor"
        stroke-width="2"
      >
        <g id="Group-3" transform="translate(25.000000, 83.000000)">
          <polyline
            id="Path-4"
            points="417.972438 192.342731 423.758314 198.128608 429.544191 192.342731"
          ></polyline>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'chevron-down',
  props: {
    iconColor: {
      type: String,
      default: '#FFF',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
